import { IconButton } from '@zennolab_platform/webui-kit/dist/ui';
import styled from 'styled-components';

import { Panel } from '../layout';

/** The pin mark of the first column, as in the pfm profile table; a block, so the cell centres it (inline, it sits on the text baseline). */
export const PinMark = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;

  &:disabled {
    cursor: default;
  }
`;

/** Type tag and, for important items, the «Важное» tag beside it. */
export const TypeCell = styled.span`
  display: inline-flex;
  gap: 4px;
`;

export const TitleCell = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;

  & > a {
    min-width: 0;
  }
`;

/** Hidden until the row is hovered or the button is focused or open; opacity keeps it reachable by keyboard. */
export const RowMenuButton = styled(IconButton)`
  margin-left: auto;
  flex-shrink: 0;
  opacity: 0;

  tr:hover &,
  &:focus-visible,
  &.ant-dropdown-open {
    opacity: 1;
  }
`;

/** One scroll for the whole page: the panel grows with the table, the pager sticks to the bottom (pfm). */
export const ListPanel = styled(Panel)`
  flex: 1 0 auto;
`;

export const TableArea = styled.div`
  flex: 1 0 auto;
`;

export const Pager = styled.div`
  position: sticky;
  bottom: -20px;
  z-index: 10;
  display: flex;
  justify-content: flex-end;
  margin: 0 -20px -20px;
  padding: 12px 20px 20px;
  border-radius: 0 0 8px 8px;
  background: ${p => p.theme.color.Neutral0};

  html[data-embedded='true'] & {
    margin: 0 0 -20px;
    padding: 12px 0 20px;
  }
`;
